import script from "./StaffDatatableTDLastLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffDatatableTDLastLogin.vue?vue&type=script&setup=true&lang=js"

import "./StaffDatatableTDLastLogin.vue?vue&type=style&index=0&id=f94b2be6&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f94b2be6"]])

export default __exports__